import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Box
} from '@mui/material';
import { ChevronRight, Home } from '@mui/icons-material';
import './Breadcrumbs.css';

const Breadcrumbs = ({ customItems = [] }) => {
  const location = useLocation();
  
  // Generate breadcrumb items based on current path
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    const breadcrumbs = [];
    
    // Home breadcrumb
    breadcrumbs.push({
      label: 'Accueil',
      path: '/',
      icon: <Home className="breadcrumb-icon" />
    });
    
    // Generate breadcrumbs from path
    let currentPath = '';
    pathnames.forEach((pathname, index) => {
      currentPath += `/${pathname}`;
      
      // Skip dynamic segments like :id
      if (pathname.match(/^[0-9]+$/)) {
        return;
      }
      
      let label = pathname;
      
      // Custom labels for known routes
      switch (pathname) {
        case 'missions':
          label = 'Missions';
          break;
        case 'mission':
          label = 'Détail Mission';
          break;
        case 'profile':
          label = 'Profil';
          break;
        case 'dashboard':
          label = 'Tableau de bord';
          break;
        case 'organizations':
          label = 'Organisations';
          break;
        case 'favorites':
          label = 'Favoris';
          break;
        default:
          // Capitalize first letter
          label = pathname.charAt(0).toUpperCase() + pathname.slice(1);
      }
      
      breadcrumbs.push({
        label,
        path: currentPath,
        isLast: index === pathnames.length - 1
      });
    });
    
    return breadcrumbs;
  };
  
  // Use custom items if provided, otherwise generate from path
  const items = customItems.length > 0 ? customItems : generateBreadcrumbs();
  
  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }
  
  return (
    <Box className="breadcrumbs-container">
      <MuiBreadcrumbs
        separator={<ChevronRight className="breadcrumb-separator" />}
        aria-label="Navigation"
        className="breadcrumbs-wrapper"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          if (isLast) {
            return (
              <Typography
                key={item.path || index}
                className="breadcrumb-current"
                variant="body2"
                aria-current="page"
              >
                {item.icon && item.icon}
                {item.label}
              </Typography>
            );
          }
          
          return (
            <Link
              key={item.path || index}
              to={item.path}
              className="breadcrumb-link"
              aria-label={`Aller à ${item.label}`}
            >
              {item.icon && item.icon}
              {item.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;